import { Loader2 } from 'lucide-react';
import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAppState } from '../../context/AppStateContext';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

export const AppLayout = ({ onRefresh }) => {
  const { currentUser, loading } = useAppState();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="relative flex h-screen">
        <Sidebar sidebarOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        {sidebarOpen && (
          <div
            className="fixed inset-0 z-40 bg-black/50 lg:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}
        <div className="flex-1 flex flex-col overflow-hidden">
          <Header onOpenSidebar={() => setSidebarOpen(true)} onRefresh={onRefresh} />
          <main className="flex-1 overflow-x-hidden overflow-y-auto p-4 sm:p-5 lg:p-6">
            <div className="max-w-7xl mx-auto">
              {loading && (
                <div className="fixed top-4 right-4 z-50 px-4 py-2.5 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-md">
                  <div className="flex items-center space-x-2.5">
                    <Loader2 className="h-4 w-4 animate-spin text-indigo-600" />
                    <span className="text-sm font-medium text-gray-700 dark:text-gray-200">Loading...</span>
                  </div>
                </div>
              )}
              <div key={location.pathname} className="animate-fadeInUp">
                <Outlet context={{ currentUser }} />
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};
